import { Component } from '@angular/core';

@Component({
  selector: 'app-pages',
  styleUrls: ['./pages.component.scss'],
  templateUrl: './pages.component.html'
})
export class PagesComponent {}
